import { atom } from 'recoil'

export const sidebarState = atom<Sidebar>({
  key: 'sidebarState',
  default: {
    isShowLeft: true,
    isShowRight: true,
  },
})

type Sidebar = {
  isShowLeft: boolean
  isShowRight: boolean
}
